export const setCheckedAndHalfCheckedKeys = 'set-checked-and-half-checked-keys';
export const setCheckedKeys = 'set-checked-keys';
export const setHalfCheckedKeys = 'set-half-checked-keys';
export const toggleExpandAction = 'toggle-expand-action';
